import React from 'react';
import Text from 'shared/components/text';
import {useAccountSettingsContext} from '../../../components/AccountSettings/AccountSettingsContext';
import {HighSchoolAccountSettings} from './high-school-account-settings';
import Checkbox from 'shared/components/checkbox';
import Title from 'src/components/AccountSettings/Title';
import {Link} from 'react-router-dom';

interface Props {
  connectionSettingTitle: string;
  connectionLabel?: string;
}
export function PrivacyForm({connectionSettingTitle, connectionLabel}: Props) {
  const {
    saveSettings,
    settings: {autoConnectCounselors, shareDataWithAllSchools},
    isSubmitting,
  } = useAccountSettingsContext<HighSchoolAccountSettings>();

  return (
    <div className="account-settings-form">
      <Title>Privacy Settings</Title>
      <section className="account-settings-form-section borderless">
        <div className="form-container">
          <Text weight={4} emphasis showOverflow>
            {connectionSettingTitle}
          </Text>
          <Text weight={5} showOverflow>
            Connecting to your counselor helps them to give you the best advice and recommendations
            possible because they are able to view your portfolio, scholarship awards, and the
            colleges you&apos;re following.
          </Text>
          <Checkbox
            checked={autoConnectCounselors}
            onChange={(e) => {
              saveSettings({autoConnectCounselors: e.target.checked});
            }}
            disabled={isSubmitting}
            label={connectionLabel ? connectionLabel : connectionSettingTitle}
            className="mb-30"
          />
          <>
            <Text weight={4} emphasis showOverflow className="margin-top">
              Data Sharing
            </Text>
            <Text weight={5} showOverflow>
              Share my portfolio with all colleges on Raise Me not just the ones I follow.
            </Text>
            <Checkbox
              checked={shareDataWithAllSchools}
              onChange={(e) => {
                saveSettings({shareDataWithAllSchools: e.target.checked});
              }}
              disabled={isSubmitting}
              label="Allow all colleges to see my data"
              className="mb-12"
            />
          </>

          <Link to="/colleges-who-have-viewed-me" className="caption">
            Click here to see colleges that have viewed you
          </Link>
        </div>
      </section>
    </div>
  );
}

export default PrivacyForm;
